import getUserConfiguration from "owa-session-store/lib/actions/getUserConfiguration";
import { getStore as getFavoritesStore, onFavoritesLoaded } from "owa-favorites";
import type FolderInfoResponseMessage from "owa-service/lib/contract/FolderInfoResponseMessage";
import type BaseFolderType from "owa-service/lib/contract/BaseFolderType";
import getPublicFolders from "../services/getPublicFolders";
import addPublicFolderToStore from "../actions/addPublicFolderToStore";
import publicFolderFavoriteStore from "../store/publicFolderFavoriteStore";
import { mapOWSFolderToGql } from "owa-folder-gql-mappers";
import type { MailFolder } from "owa-graph-schema";
import type { FavoritePublicFolderData } from "owa-favorites-types";
import { type AccountKey, isSameCoprincipalAccountByMailboxAndAccountKey } from "owa-client-types";
import { getMailboxInfoForPublicFolder } from "owa-mailbox-info/lib/getMailboxInfoForPublicFolder";
import getGlobalSettingsAccountMailboxInfo from "owa-account-source-list-store/lib/selectors/getGlobalSettingsAccountMailboxInfo";
import { orchestrator } from "satcheljs";

orchestrator(onFavoritesLoaded, async (actionMessage) => {
    const defaultPublicFolderMailbox = getUserConfiguration()?.SessionSettings?.DefaultPublicFolderMailbox;
    if (!defaultPublicFolderMailbox) {
        return;
    }
    const mailboxInfo = getMailboxInfoForPublicFolder(getGlobalSettingsAccountMailboxInfo(), defaultPublicFolderMailbox);
    
    const folderIds: string[] = getFavoritePublicFolderIdsV2(actionMessage.accountKey);
    const getFolderResponse = await getPublicFolders(folderIds, mailboxInfo);
    getFolderResponse?.Items?.forEach((item: FolderInfoResponseMessage) => {
        item.Folders?.forEach((folder: BaseFolderType) => {
            if (folder != null) {
                const mailFolder: MailFolder | null = mapOWSFolderToGql(folder, mailboxInfo);
                if (mailFolder) {
                    addPublicFolderToStore(publicFolderFavoriteStore(), mailFolder);
                }
            }
        });
    });
});

function getFavoritePublicFolderIdsV2(accountKey: AccountKey) {
    const favoritesStore = getFavoritesStore();
    const allFavorites = [...favoritesStore.outlookFavorites.values()];
    return allFavorites
        .filter(favorite => {
        let isAllowedMailbox = true;
        if (favorite.mailboxInfo) {
            isAllowedMailbox = isSameCoprincipalAccountByMailboxAndAccountKey(favorite.mailboxInfo, accountKey);
        }
        return isAllowedMailbox && favorite.type === "publicFolder";
    })
        .map(favoriteData => {
        return (favoriteData as FavoritePublicFolderData).publicFolderId;
    });
}
